import React from 'react';

const ProcessBoxTwo = ({className, icon, title, text})=> (
  <div className={`vs-process ${className || ''}`}>
    <div className="process-icon">
      <img src={icon} alt="icon"/>
    </div>
    <h3 className="process-title h5">{title}</h3>
    <p className="process-text">{text}</p>
  </div>
);

export default ProcessBoxTwo;